import VueCookies from 'vue-cookies'
VueCookies.config('90d')

export const SetReviewDetail = ({ commit }, sessionId, flag) => {
  commit('SET_REVIEWDETAIL', sessionId, flag)
}




// WEBPACK FOOTER //
// ./src/store/modules/review/action.js